export const title = 'Donations';
export const tableHeads = ['Name', 'Amount', 'Date'];
export const itemToRender = 10;
